import { TranslatedText } from "@/components/common/text";
import { useMemo } from "react";
import { MarketCard } from "@/components/home/MarketCard";
import { ErrorComponent } from "@/components/common/errors";
import { Skeleton } from "@/components/common/other/Skeleton";

export const TrendsRow = ({ trailerType, numOfDays, trends }) => {
    const sortedMarkets = useMemo(() => {
        if (trends.error || trends.loading) return [];
        else {
            return trends.data
                .filter((market) => (market.confidence === "high" || market.confidence === "medium") && market.trend >= 0.5)
                .sort((a, b) => a.trend - b.trend)
                .slice(-3)
                .reverse();
        }
    }, [trends]);

    return (
        <div>
            {trends.loading ? (
                <div className="min-h-[127px] flex items-center justify-center">
                    <div className="w-full ">
                        <Skeleton className="h-[127px] rounded-lg" />
                    </div>
                </div>
            ) : trends.error ? (
                <ErrorComponent className="min-h-[130px]" />
            ) : (
                <div className="flex flex-col gap-3">
                    <div className="flex items-center gap-3">
                        <h2 className="text-[22px]/[35px] text-cm-p-text-primary font-bold text-center">
                            <TranslatedText>{trailerType}</TranslatedText>
                        </h2>
                        <p className="text-base text-cm-p-text-primary font-medium text-center">
                            <TranslatedText>{`${numOfDays} days`}</TranslatedText>
                        </p>
                    </div>
                    <div className="flex flex-col lg:flex-row items-center justify-start gap-4">
                        {sortedMarkets.map((market, i) => (
                            <MarketCard
                                key={i}
                                trend={market.trend}
                                avgRpm={market.averageStat.average}
                                name={market.averageStat.label}
                                confidence={market.confidence}
                            />
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};
